import { ComponentIds } from '@inter-ikea-core/core';
import { CoreApi, NightLightsSystem } from '@inter-ikea-storageone/range';

export const enableDarkModeIfLightsInScene = (
  coreApi: CoreApi,
  darkScene: boolean,
  selectedGroupId: string
) => {
  if (!darkScene && selectedGroupId === 'lights') {
    const currentLightsInScene = coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);

    if (currentLightsInScene.length > 0) {
      coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.enable();
      coreApi.emit.onEnableNightMode(true);
    }
  }
};

export const disableDarkModeIfNoLightsInScene = (coreApi: CoreApi, darkScene: boolean) => {
  if (darkScene) {
    const currentLightsInScene = coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);

    if (currentLightsInScene.length === 0) {
      coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.disable();
      coreApi.emit.onEnableNightMode(false);
    }
  }
};
